import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Button } from 'antd'

export const StyledDropDownMenuWrapper = styled.div`
  position: relative;
  font-size: 1rem;
  top: 4px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    top: 0;
  }
`

export const StyledDropDownLink = styled.a`
  display: flex;
  place-items: center;
  margin-left: 8px;
  color: #707070;
  font-size: 17px;
`

export const StyledLink = styled(Link)`
  color: #605c5c;
  align-self: center;
  display: flex;
`

export const StyledMenu = styled.div`
  display: grid;
  justify-items: center;

  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 1px 5px 1px rgba(224, 224, 224, 1);
`

export const StyledButtonWrapper = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  a {
    margin-right: 5px;
  }
`

export const StyledDropdownBtn = styled(Button)<{ col?: string }>`
  font-weight: bold !important;
  text-transform: capitalize;
  color: #90258c;
  border: 2px solid #90258c;
`

export const StyledUserName = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #120224;
`

export const StyledIRESSVerifiedStatusWrapper = styled.div<{ verified: boolean }>`
  height: 40px;

  display: flex;
  align-items: center;
  padding: 4px 4px 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  background-color: white;
  /* border: 1px solid ${({ verified }) => (verified ? '#a5d6a7' : '#ef9a9a')}; */
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08); */
  transition: all 0.2s ease;
  margin-right: 16px;

  /* &:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    border-color: ${({ verified }) => (verified ? '#81c784' : '#e57373')};
  } */
`

export const StyledIRESSVerifiedStatusLabel = styled.span`
  font-size: 14px;
  color: #424242;
  margin-right: 8px;
  font-weight: 500;
`

export const StyledIRESSVerificationStatus = styled.div<{ verified: boolean }>`
  height: 30px;

  display: flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 4px;
  background-color: ${({ verified }) => (verified ? '#e8f5e9' : '#ffebee')};
  color: ${({ verified }) => (verified ? '#2e7d32' : '#c62828')};
  font-weight: 600;
  font-size: 14px;
`

export const StyledIRESSVerificationStatusIcon = styled.div`
  margin-right: 6px;
  display: flex;
  align-items: center;
`

export const StyledLogo = styled.img`
  padding: 24px 0 8px 0;
  cursor: pointer;
`

export const StyledNotificationButton = styled.div`
  margin-right: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledNotificationIcon = styled.div<{ hasNotifications: boolean }>`
  font-size: 24px;
  color: ${(props) => (props.hasNotifications ? '#1890ff' : '#8c8c8c')};
`

export const StyledModalContent = styled.div`
  max-height: 400px;
  overflow-y: auto;
`

export const StyledLoadingState = styled.div`
  text-align: center;
  padding: 20px;
`

export const StyledErrorState = styled.div`
  text-align: center;
  padding: 20px;
  color: red;
`

export const StyledEmptyState = styled.div`
  text-align: center;
  padding: 20px;
  color: #8c8c8c;
`

export const StyledNotesCounter = styled.div`
  margin-bottom: 16px;
  font-weight: bold;
`

export const StyledAgentCard = styled.div`
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background-color: #fafafa;
`

export const StyledAgentName = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
`

export const StyledNoteItem = styled.div`
  margin-bottom: 12px;
`

export const StyledNoteMetadata = styled.div`
  display: flex;
  justify-content: space-between;
  color: #8c8c8c;
  font-size: 12px;
  margin-bottom: 12px;
`

export const StyledNoteContent = styled.div`
  font-weight: 500;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #fff;
  padding: 10px;
  margin-bottom: 8px;
`

export const StyledHeaderActions = styled.div`
  display: flex;
  align-items: center;
`
